import { LocalDate, convert } from "@js-joda/core";

export const convertFromString = (date: string) =>
  convert(LocalDate.parse(date)).toDate();

export const convertFromLocalDate = (date: LocalDate) => convert(date).toDate();

export const convertToNativeJsDate = (
  date: string | LocalDate | undefined | null
) => {
  if (!date) return undefined;

  if (typeof date === "string") return convertFromString(date);

  return convertFromLocalDate(date);
};
